import React from "react";
import { FaPlus, FaUndo } from "react-icons/fa";
import Button from "../../../../components/Button/Button";

export default function PassageCeintureDocumentsToolbar({
  dynamicOptions,
  ui,
  canManage,
  onChange,
  debouncedSearch,
  setDebouncedSearch,
  onReset,
  onCreate,
}) {
  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
        <div>
          <label className="block text-sm font-medium text-slate-700 dark:text-slate-200 mb-1">
            Recherche
          </label>
          <input
            type="text"
            value={debouncedSearch}
            onChange={(e) => setDebouncedSearch(e.target.value)}
            placeholder="Titre, description, ceinture..."
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 dark:text-slate-200 mb-1">
            Ceinture
          </label>
          <select
            value={ui.grade}
            onChange={(e) => onChange({ grade: e.target.value })}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
          >
            {dynamicOptions.grades.map((g) => (
              <option key={g} value={g}>
                {g}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 dark:text-slate-200 mb-1">
            Tri
          </label>
          <select
            value={ui.sort}
            onChange={(e) => onChange({ sort: e.target.value })}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
          >
            <option value="beltTitle">Ceinture &gt; Ordre &gt; Titre</option>
            <option value="belt">Ceinture &gt; Titre</option>
            <option value="alpha">Titre A-Z</option>
          </select>
        </div>

        {canManage && (
          <div className="flex items-end">
            <label className="inline-flex items-center gap-2 rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100 px-3 py-2 h-[42px]">
              <input
                type="checkbox"
                checked={ui.showDrafts}
                onChange={(e) => onChange({ showDrafts: e.target.checked })}
              />
              <span className="text-sm">Afficher aussi les brouillons</span>
            </label>
          </div>
        )}
      </div>

      <div className="flex flex-wrap gap-2 justify-end">
        <Button
          text="Réinitialiser"
          icon={FaUndo}
          onClick={onReset}
          className="rounded-xl"
        />

        {canManage && (
          <Button
            text="Ajouter un document"
            icon={FaPlus}
            onClick={onCreate}
            className="rounded-xl"
          />
        )}
      </div>
    </div>
  );
}